import React from 'react'
import ProductBanner from '../Components/productsection/ProductBanner'
import AuctionAccess from '../Components/productsection/AuctionAccess'
import { useAuth } from '../contexts/AuthContext'

function Products() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return null;

  return isAuthenticated ? <ProductBanner /> : <AuctionAccess />;
}

export default Products
